export default __webpack_public_path__ + "static/directors-ecaaa04e775f758b88bd732ef7a687a4.jpeg";